export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/reversals`,
        name: `${prefix}.reversals.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.reversals.create`,
                PageDescription: "Accounts: Reversals",
            },
        },
    },
];
